import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _get from "lodash/get";

var _templateObject;

import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { DialogContent } from '@reach/dialog';
import { baseTheme } from '~base-theme';
import { media } from '~layout';
import modalTheme from '../../styles/modalTheme';
var ModalContent = styled(DialogContent).withConfig({
  displayName: "ModalContent",
  componentId: "sc-10u3h04-0"
})(["background-color:", ";border-radius:", ";box-shadow:0 0 32px 8px ", ";margin:5vh 5vw;overflow:hidden;z-index:", ";", " ", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return _get(theme, 'modal.backgroundColor', modalTheme.modal.backgroundColor);
}, function (_ref2) {
  var theme = _ref2.theme;
  return rem(_get(theme, 'base.borderRadius.default', baseTheme.base.borderRadius.default));
}, function (_ref3) {
  var theme = _ref3.theme;
  return _get(theme, 'modal.content.boxShadowColor', modalTheme.modal.content.boxShadowColor);
}, function (_ref4) {
  var theme = _ref4.theme;
  return _get(theme, 'modal.content.zIndex', modalTheme.modal.content.zIndex);
}, function (_ref5) {
  var $isOverlayTransparent = _ref5.$isOverlayTransparent,
      theme = _ref5.theme;
  return $isOverlayTransparent && css(["box-shadow:", ";"], _get(theme, 'base.boxShadow.elevationLarge', baseTheme.base.boxShadow.elevationLarge));
}, function (_ref6) {
  var theme = _ref6.theme,
      $modalSize = _ref6.$modalSize;
  return $modalSize && css(["", ""], media.sm(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n            margin: 15vh auto;\n                max-width: ", ";\n            "])), rem(_get(theme, "modal.width[" + $modalSize + "]", modalTheme.modal.width[$modalSize]))));
}, function (_ref7) {
  var $offsetTop = _ref7.$offsetTop;
  return $offsetTop && css(["margin-top:", ";"], rem($offsetTop));
});
export default ModalContent;